import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { downloadGenerateReports, reportDownloadAWSBucket } from "../../config/LiveApi";
import "./DownloadGenrate.css";
import GenrateReport from "../DownloadReports/index";
import { FaDownload, FaTimes } from "react-icons/fa";

const DownloadGenerateReports = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [isLoading, setIsLoading] = useState(false);
  const [reports, setReports] = useState([]);
  const [showGenerateReport, setShowGenerateReport] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const fetchReports = async () => {
      try {
        const response = await downloadGenerateReports(token);
        if (response?.statusCode === 200) {
          const sortedReports = response.data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setReports(sortedReports);
        } else {
          console.log("Failed to fetch reports");
        }
      } catch (err) {
        console.log(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchReports();
  }, [token]);

  const handleDownload = async (path) => {
    if (!path) {
      toast.error("Invalid file name.");
      return;
    }

    try {
      const response = await reportDownloadAWSBucket(path, token);
      // console.log("response", response)
      const downloadUrl = response?.data?.downloadUrl;

      // console.log("downloadUrl", downloadUrl)

      if (response?.data?.statusCode === 200 && downloadUrl) {
        window.location.href = downloadUrl;
      } else {
        toast.error("Failed to get download URL.");
      }
    } catch (error) {
      // console.log("error", error)
      toast.error("Error downloading the file.");
    }
  };






  return (
    <div className="download-report-table-container">
      <h2 className="download-report-table-title">Download Reports</h2>

      <div className="download-report-option">
        <p className="text-report-generate">
          Note: Transactions done take some time to
          appear in the report.
        </p>
        <button
          className="btn-report-generate"
          onClick={() => setShowGenerateReport(true)}
        >
          Generate Report
        </button>
      </div>

      {showGenerateReport && (
        <div className="modal-overlay-download">
          <div className="modal-content-download">
            <div className="fixed-close-btn close-btn-download" onClick={() => {
              setShowGenerateReport(false);
            }}>
              <FaTimes />
            </div>
            <GenrateReport />
          </div>
        </div>
      )}

      <table className="wallet-table">
        <thead>
          <tr>
            <th>Report Type</th>
            <th>Report Generate Date</th>
            <th>User Name</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="5">Loading...</td>
            </tr>
          ) : reports.length === 0 ? (
            <tr>
              <td colSpan="5">
                <div className="no-report-message">
                  <h3>Oops</h3>
                  <p className="msg-no-report">
                    No Generate Report History Found
                  </p>
                </div>
              </td>
            </tr>
          ) : (
            reports.map((report) => (
              <tr key={report.id}>
                <td>{report.type || "N/A"}</td>
                <td>
                  {new Date(report.createdAt).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}{" "}
                  {new Date(report.createdAt).toLocaleTimeString("en-GB", {
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: true,
                  })}
                </td>
                <td>{report.userName}</td>
                <td>{report.status ? "Complete" : "Pending"}</td>
                <td>
                  {report.status ? (
                    <button className="download-btn-report-1" onClick={() => handleDownload(report.path)}>
                      <FaDownload className="download-icon" />
                    </button>
                  ) : (
                    "Not Available"
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};
//new branch

export default DownloadGenerateReports;